import React from 'react';
import Modal from './modal';

export default function CookieModal({ onClose }) {
  return (
    <Modal title="Cookie Policy" onClose={onClose}>
      <h3>What Are Cookies?</h3>
      <p>Cookies are small text files placed on your device when you visit a website. They help the site function properly, remember your preferences, and gather analytics data.</p>

      <h3>Cookies We Use</h3>
      <ul>
        <li><strong>Strictly necessary cookies:</strong> Required for basic site functionality such as navigation and age verification.</li>
        <li><strong>Analytics cookies:</strong> Help us understand how visitors interact with the site (e.g. Google Analytics).</li>
        <li><strong>Preference cookies:</strong> Remember your consent decisions and display settings.</li>
        <li><strong>Affiliate cookies:</strong> Track referrals to our partner casino sites for commission reporting. These are set by third-party operators when you click our links.</li>
      </ul>

      <h3>Managing Cookies</h3>
      <p>You can disable cookies through your browser settings. Note that disabling cookies may affect site functionality. Most browsers allow you to refuse third-party cookies while accepting first-party cookies.</p>

      <h3>Third-Party Cookies</h3>
      <p>Clicking affiliate links to casino partners may result in tracking cookies being set by those operators. We are not responsible for third-party cookie practices.</p>

      <h3>Contact</h3>
      <p>Questions about our cookie usage? Email info@londoncasinodeals.com</p>

      <p style={{ marginTop: 20, fontSize: '0.78rem', color: '#8fa3c4' }}>Last updated: April 2026</p>
    </Modal>
  );
}
